import type { Instance, SnapshotIn } from 'mobx-state-tree'


import { CenterSettingsStore } from './CenterSettingsStore'
import { ChecklistReportsStore } from './ChecklistReportsStore'
import { ChecklistsStore } from './ChecklistsStore'
import { LoginStore } from './LoginStore'
import { MapEntitiesStore } from './MapEntitiesStore'
import { MissionHistoryStore } from './MissionHistoryStore'
import { NavbarStore } from './NavbarStore'
import { UsersStore } from './UsersStore'
import { PartNumbersStore } from './PartNumbersStore'
import { DiscrepancyReportsStore } from './DiscrepancyReportsStore'
import { CommonSettingsStore } from './CommonSettingsStore'
import { NotificationStore } from './NotificationStore'
import { VehiclesStore } from './VehiclesStore'

import { makeEnvironmentModel } from '../models/makeEnvironmentModel'
import FlightNetworkStore from './FlightNetworkStore'

export interface RootStoreModelEnvironment {}

const RootStoreModel = makeEnvironmentModel<RootStoreModelEnvironment>('RootStoreModel').props({
  // Common stores
  notificationStore: NotificationStore,
  commonSettingsStore: CommonSettingsStore,
  navbarStore: NavbarStore,

  // Per page stores
  flightNetworkStore: FlightNetworkStore,
  centerSettingsStore: CenterSettingsStore,
  loginStore: LoginStore,
  checklistReportsStore: ChecklistReportsStore,
  usersStore: UsersStore,
  missionHistoryStore: MissionHistoryStore,
  checklistsStore: ChecklistsStore,
  partNumbersStore: PartNumbersStore,
  discrepancyReportsStore: DiscrepancyReportsStore,
  vehiclesStore: VehiclesStore,
  mapEntitiesStore: MapEntitiesStore,
})

type RootStoreModelType = typeof RootStoreModel

export interface RootStoreModelInstance extends Instance<RootStoreModelType> {}
export interface RootStoreModelSnapshotIn extends SnapshotIn<RootStoreModelType> {}

export interface WithMissionHistoryStore extends Pick<RootStoreModelInstance, 'missionHistoryStore'> {}
export interface WithCenterSettingsStore extends Pick<RootStoreModelInstance, 'centerSettingsStore'> {}
export interface WithNavBarStore extends Pick<RootStoreModelInstance, 'navbarStore'> {}
export interface WithFlightNetworkStore extends Pick<RootStoreModelInstance, 'flightNetworkStore'> {}
export interface WithChecklistReportsStore extends Pick<RootStoreModelInstance, 'checklistReportsStore'> {}
export interface WithLoginStore extends Pick<RootStoreModelInstance, 'loginStore'> {}
export interface WithMapEntitiesStore extends Pick<RootStoreModelInstance, 'mapEntitiesStore'> {}
export interface WithUsersStore extends Pick<RootStoreModelInstance, 'usersStore'> {}
export interface WithChecklistsStore extends Pick<RootStoreModelInstance, 'checklistsStore'> {}
export interface WithVehiclesStore extends Pick<RootStoreModelInstance, 'vehiclesStore'> {}
export interface WithCommonSettingsStoreStore extends Pick<RootStoreModelInstance, 'commonSettingsStore'> {}
export interface WithNotificationStore extends Pick<RootStoreModelInstance, 'notificationStore'> {}
export interface WithPartNumbersStore extends Pick<RootStoreModelInstance, 'partNumbersStore'> {}
export interface WithDiscrepancyReportsStore extends Pick<RootStoreModelInstance, 'discrepancyReportsStore'> {}

export type MapEntitiesStoreType = WithMapEntitiesStore['mapEntitiesStore']
export type CommonSettingsStoreType = WithCommonSettingsStoreStore['commonSettingsStore']
export type FlightNetworkStoreType = WithFlightNetworkStore['flightNetworkStore']

export function createRootStoreModel(
  rootStoreModelSnapshot: RootStoreModelSnapshotIn,
  rootStoreModelEnvironment: RootStoreModelEnvironment,
): RootStoreModelInstance {
  return RootStoreModel.create(rootStoreModelSnapshot, rootStoreModelEnvironment)
}

export interface WithRootStore {
  store: RootStoreModelInstance
}
